export const TOGGLE_PASS_ERR = 'loginn/TOGGLE_PASS_ERR';
export const TOGGLE_USERNAME_ERR = 'loginn/TOGGLE_USERNAME_ERR';
export const HANDLE_USERNAME_CHANGE = 'loginn/HANDLE_USERNAME_CHANGE';
export const HANDLE_PASSWORD_CHANGE = 'loginn/HANDLE_PASSWORD_CHANGE';
export const RESET_FORM = 'loginn/RESET_FORM';
export const MANU_BTN_CLICK = 'loginn/MANU_BTN_CLICK';













